// extracted by mini-css-extract-plugin
export default {"container":"container__LliGE","title":"title__aDzvZ","list":"list__4oQgX","item":"item__uaXNe","icon":"icon__sFVUH"};